'use client';

import { useStakeholdersNotifications } from '@/hooks/useStakeholdersNotifications';
import { useSession } from '@descope/nextjs-sdk/client';
import { useQuery } from '@tanstack/react-query';
import { getPendingInvitations } from '@/services/teams.service';
import { TeamInvitationPopup } from '@/components/teams/components/TeamInvitationPopup';

export function GlobalNotifications() {
	useStakeholdersNotifications();

	const { isAuthenticated } = useSession();

	const { data: pendingInvitations, refetch } = useQuery({
		queryKey: ['pendingInvitations'],
		queryFn: () => getPendingInvitations(),
		enabled: isAuthenticated,
		staleTime: 30000,
	});

	const firstPending = pendingInvitations?.[0];

	if (!firstPending) {
		return null;
	}

	return (
		<TeamInvitationPopup
			invitation={firstPending}
			onResolved={() => refetch()}
		/>
	);
}
